$(document).ready(function() {
	$('.product-single__sticky').scrollToFixed({
        marginTop: function() {
            var marginTop = $(window).height() - $('.product-single__sticky').outerHeight(true) - 20;
            if (marginTop >= 0) return 20;
            return marginTop;
        }
    });
});

$('.shopify-currency-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});

$('#infiniteoptions-container').click(function() {
	//Show Template Upload Area if something selected
   $('#upload_area').show('slow');
	 setTimeout(function (){
		 //to fight off infinite options and hide on "None"
		 var selected = $("input[type='radio'][name='properties[Customization]'][value='None']:checked");
			if (selected.length > 0) {
				console.log('None Checked');
			  $('#upload_area').hide('slow');
			}
	}, 1000);
});




$(function() {
	//Home Page Slider (bottom)
	$('.slider-products').on('init', function() {
		$(".slick-active").prev().removeClass('nextdiv').addClass('prevdiv');
		$(".slick-active").next().removeClass('prevdiv').addClass('nextdiv');
	});
	var numSlick = 0;
	$('.slider-products').each(function() {
		numSlick++;
		$(this).addClass('slider-' + numSlick).slick({
			focusOnSelect: true,
			slidesToShow: 1,
			center: true,
			infinite: true,
			arrows: true,
			prevArrow: '<div class="slick-prev"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="52px" height="18px" viewBox="0 0 52 18" style="overflow:visible;enable-background:new 0 0 52 18;" xml:space="preserve"><g><polygon class="st0" points="10,18 11.1,16.9 3.1,9.7 52,9.7 52,8.1 3.1,8.1 11.1,1.1 10,0 0,8.9 	"></polygon></g></svg></div>',
			nextArrow: '<div class="slick-next"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="52px" height="18px" viewBox="0 0 52 18" style="overflow:visible;enable-background:new 0 0 52 18;" xml:space="preserve"><g><polygon class="st0" points="41.9,0 40.9,1.1 48.8,8.3 0,8.3 0,9.9 48.8,9.9 40.9,16.9 41.9,18 52,9.1 	"/></g></svg></div>',
			asNavFor: '.slider-nav'
		}).on('beforeChange', function() {
			console.log($(".slick-active"));
			$(".slider-products .slick-slide").removeClass('nextdiv');
			$(".slider-products .slick-slide").removeClass('prevdiv');
		}).on('afterChange', function() {
			console.log($(".slick-active"));
			$(".slider-products .slick-active").prev().removeClass('nextdiv').addClass('prevdiv');
			$(".slider-products .slick-active").next().removeClass('prevdiv').addClass('nextdiv');
		});
	});

	numSlick = 0;
	$('.slider-nav').each(function() {
		numSlick++;
		$(this).addClass('slider-' + numSlick).slick({
			vertical: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: '.slider-products.slider-' + numSlick,
			arrow: false,
			focusOnSelect: true,
			responsive: [{
				breakpoint: 800,
				settings: {
					slidesToShow: 3,
				}
			}]
		});
	});
		$('.slider-products').show();
});






$('.slider-simple').on('init', function() {
	$(this).css("visibility", "visible");
	$(".slick-active").prev().removeClass('nextdiv').addClass('prevdiv');
	$(".slick-active").next().removeClass('prevdiv').addClass('nextdiv');
});

var numSimpleSlick = 0;
$('.slider-simple').each(function() {
	numSimpleSlick++;
	$(this).addClass('slider-' + numSimpleSlick).slick({
		focusOnSelect: true,
		arrows: true,
		prevArrow: '<div class="slick-prev"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="52px" height="18px" viewBox="0 0 52 18" style="overflow:visible;enable-background:new 0 0 52 18;" xml:space="preserve"><g><polygon class="st0" points="10,18 11.1,16.9 3.1,9.7 52,9.7 52,8.1 3.1,8.1 11.1,1.1 10,0 0,8.9 	"></polygon></g></svg></div>',	
		nextArrow: '<div class="slick-next"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="52px" height="18px" viewBox="0 0 52 18" style="overflow:visible;enable-background:new 0 0 52 18;" xml:space="preserve"><g><polygon class="st0" points="41.9,0 40.9,1.1 48.8,8.3 0,8.3 0,9.9 48.8,9.9 40.9,16.9 41.9,18 52,9.1 	"/></g></svg></div>',
		responsive: [{
			breakpoint: 800,
			settings: {
				slidesToShow: 1,
			}
		}]
	}).on('beforeChange', function() {
		console.log('Im Main Slider');
		$(".slider-simple .slick-slide").removeClass('nextdiv');
		$(".slider-simple .slick-slide").removeClass('prevdiv');
	}).on('afterChange', function() {

		$(".slider-simple .slick-active").prev().removeClass('nextdiv').addClass('prevdiv');
		$(".slider-simple .slick-active").next().removeClass('prevdiv').addClass('nextdiv');
	});
});

numSimpleSlickNav = 0;
$('.slider-simple-nav').each(function() {
	numSimpleSlickNav++;
	$(this).addClass('slider-nav-' + numSimpleSlickNav).slick({
		vertical: false,
		slidesToShow: 10,
		slidesToScroll: 1,
		asNavFor: '.slider-simple.slider-' + numSimpleSlickNav,
		arrow: false,
		focusOnSelect: true,
		responsive: [{
			breakpoint: 800,
			settings: {
				slidesToShow: 1,
			}
		}]
	}).on('beforeChange', function() {
		console.log('Im Nav for Slider');

	}).on('afterChange', function() {

	});
});


$('.slider-simple-single').on('init', function() {
	$(this).css("visibility", "visible");
	$(".slick-active").prev().removeClass('nextdiv').addClass('prevdiv');
	$(".slick-active").next().removeClass('prevdiv').addClass('nextdiv');
});



var numSimpleSingleSlick = 100;
$('.slider-simple-single').each(function() {
	numSimpleSlick++;
	$(this).addClass('slider-' + numSimpleSingleSlick).slick({
		focusOnSelect: true,
		slidesToShow: 1,
		arrows: false,
		asNavFor: '.slider-simple-single-nav.slider-nav-' + numSimpleSingleSlick,
		responsive: [{
			breakpoint: 800,
			settings: {
				slidesToShow: 1,
			}
		}]
	}).on('beforeChange', function() {
		console.log('Im Main Slider');
		$(".slider-simple-single .slick-slide").removeClass('nextdiv');
		$(".slider-simple-single .slick-slide").removeClass('prevdiv');
	}).on('afterChange', function() {

		$(".slider-simple-single .slick-active").prev().removeClass('nextdiv').addClass('prevdiv');
		$(".slider-simple-single .slick-active").next().removeClass('prevdiv').addClass('nextdiv');
	});
});

numSimpleSlickSingleNav = 100;
$('.slider-simple-single-nav').each(function() {
	numSimpleSlick++;
	$(this).addClass('slider-nav-' + numSimpleSlickSingleNav).slick({
		vertical: false,
		slidesToShow: 10,
		slidesToScroll: 1,
		asNavFor: '.slider-simple-single.slider-' + numSimpleSlickSingleNav,
		arrow: false,
		focusOnSelect: true,
		responsive: [{
			breakpoint: 800,
			settings: {
				slidesToShow: 1,
			}
		}]
	}).on('beforeChange', function() {
		console.log('Im Nav for Slider');

	}).on('afterChange', function() {

	});
});





var numrepeaterSlick = 0;
$('.slider-repeater').each(function() {
	numrepeaterSlick++;
	console.log(numrepeaterSlick);
	$(this).addClass('slider-' + numrepeaterSlick).slick({
		focusOnSelect: true,
		slidesToShow: 1,
		arrows: false,
		asNavFor: '.slider-repeater-nav.slider-nav-' + numrepeaterSlick,
		responsive: [{
			breakpoint: 800,
			settings: {
				slidesToShow: 1,
			}
		}]
	}).on('beforeChange', function() {

	}).on('afterChange', function() {


	});
});

var numrepeaterSlickNav = 0;
$('.slider-repeater-nav').each(function() {
	numrepeaterSlickNav++;
	$(this).addClass('slider-nav-' + numrepeaterSlickNav).slick({
		vertical: false,
		slidesToShow: 10,
		slidesToScroll: 1,
		asNavFor: '.slider-repeater.slider-' + numrepeaterSlickNav,
		arrow: false,
		focusOnSelect: true,
		responsive: [{
			breakpoint: 800,
			settings: {
				slidesToShow: 1,
			}
		}]
	}).on('beforeChange', function() {
		console.log('Im Nav for Slider');

	}).on('afterChange', function() {

	});
});
